import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React, { useRef } from 'react';
import { IStyle } from 'Styles';
import DropImageSettingsDropdown from './DropImageSettingsDropdown';
import { useDropImageSettings } from 'components/well/hooks';

interface Props {
  customizeSettingsClassName?: string;
  disabled: boolean;
  canvasMode?: boolean;
  wrapperClassName?: string;
}

const DropImageSettings = (props: Props) => {
  const {
    customizeSettingsClassName,
    disabled,
    canvasMode = false,
    wrapperClassName = 'w-[90%]',
  } = props;
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const dropdownWrapperRef = useRef<HTMLDivElement>(null);

  const onMenuClick = () => {
    if (!disableDropImageSettings && !disabled) {
      setIsMenuOpen((prev) => !prev);
    }
  };

  const {
    setDefaultRegionCaptureProfile,
    disableDropImageSettings,
    imageSettingText,
    imageSettingsPills,
    titleTip,
    deleteSingleDropSetting,
    imageSettingsList,
  } = useDropImageSettings();

  return (
    <div
      id="commandpanel-exptools-dropimagesettings-wrapper"
      className={`flex flex-row ${wrapperClassName} ${
        disableDropImageSettings || disabled
          ? 'pointer-events-none cursor-none opacity-30'
          : ''
      }`}
    >
      <div
        id="commandpanel-exptools-dropimagesettings-header"
        className={`flex w-1/3 align-center ${
          canvasMode ? 'shrink-0 whitespace-nowrap' : ''
        }`}
        style={styles.imageSettingHeading}
      >
        Imaging Setting
      </div>
      <div
        id="commandpanel-exptools-dropimagesettings-content"
        className="flex flex-row min-w-0 w-full border border-[#999999] rounded-sm cursor-pointer"
        onClick={onMenuClick}
        ref={dropdownWrapperRef}
      >
        <div
          id={`commandpanel-exptools-dropimagesettings-${titleTip}`}
          className="flex flex-row items-center inputFieldDetails border-none min-w-0 w-[85%] min-h-[32px] px-1"
          title={titleTip}
        >
          <div className="flex flex-wrap items-center gap-1 min-w-0 w-full">
            {imageSettingsPills?.map((value, i) => (
              <div
                id={`commandpanel-exptools-dropimagesettings-pill-${value}`}
                key={`actBanner${i}`}
                className="inline-flex items-center gap-1 max-w-[10rem] px-2 py-0.5 text-[14px] leading-5 rounded-full bg-[#DEE2E6]"
              >
                <label className="truncate whitespace-nowrap">
                  {value.length > 8 ? `${value.slice(0, 8)}...` : value}
                </label>
                <div
                  id={`commandpanel-exptools-dropimagesettings-pillremove-${value}`}
                  className="flex shrink-0 items-center justify-center"
                >
                  <RMCustomButton
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteSingleDropSetting(value);
                    }}
                    iconProps={{ name: 'CrossRounded', fill: '#737373' }}
                    iconClass="rounded-sm"
                    isDisabled={disabled}
                  />
                </div>
              </div>
            ))}
            {imageSettingText && imageSettingText.length > 0 && (
              <label className="truncate whitespace-nowrap">{imageSettingText}</label>
            )}
          </div>
          <div
            id="commandpanel-exptools-dropimagesettings-text"
            className="flex shrink-0 items-center justify-start w-[15%] text-lg"
          >
            {imageSettingsList.length > 2 ? ` + ${imageSettingsList.length - 2}` : ''}
          </div>
        </div>
        <div
          id="commandpanel-exptools-dropimagesettings-dropdownbutton"
          className="flex justify-center w-[15%] items-center text-[14px]"
          style={styles.select}
        >
          <DropImageSettingsDropdown
            setIsMenuOpen={setIsMenuOpen}
            wrapperRef={dropdownWrapperRef}
            isMenuOpen={isMenuOpen}
            customizeSettingsClassName={customizeSettingsClassName}
            imageSettingsList={imageSettingsList}
            setDefaultRegionCaptureProfile={setDefaultRegionCaptureProfile}
            canvasMode={canvasMode}
          />
        </div>
      </div>
    </div>
  );
};

export default DropImageSettings;

const styles: IStyle = {
  select: {
    borderLeft: '1px solid #DEE2E6',
  },
  imageSettingHeading: {
    paddingInline: '1%',
  },
};
